// components/QuoteSection/QuoteSection.jsx
import React, { useEffect, useMemo, useState } from 'react';
import axios from 'axios';
import { motion } from 'framer-motion';
import { API_BASE } from '../config/api';
import './css/QuoteSection.css';

const QuoteSection = () => {
  const defaultQuote = useMemo(
    () => ({
      quote_text:
        'الاستشارة الأكاديمية ليست رفاهية، بل أداة ذكية تسبق بها الطالبة غيرها، وتختصر عليها سنوات من المعاناة.',
      quote_author: 'د. نهى الحازمي',
    }),
    []
  );

  const [quote, setQuote] = useState(defaultQuote);

  useEffect(() => {
    let mounted = true;
    axios
      .get(`${API_BASE}/api/quote`)
      .then((res) => {
        const dbQuote = res.data?.quote;
        if (!mounted) return;
        setQuote(dbQuote ? { ...defaultQuote, ...dbQuote } : defaultQuote);
      })
      .catch((err) => {
        console.error('Failed to load quote:', err);
        if (!mounted) return;
        setQuote(defaultQuote);
      });

    return () => {
      mounted = false;
    };
  }, [defaultQuote]);

  return (
    <section className="quote-section" dir="rtl">
      <div className="container">
        <div className="row align-items-center justify-content-center">
          
          {/* Quote Icon Column */}
          <div className="col-md-3 text-center text-md-end">
            <motion.div 
              className="quote-icon"
              initial={{ scale: 0 }}
              whileInView={{ scale: 1 }}
              viewport={{ once: true }}
              transition={{ type: 'spring', stiffness: 100 }}
            >
              ❝
            </motion.div>
          </div>

          {/* Text Column */}
          <div className="col-md-8">
            <motion.div 
              className="quote-content"
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
            >
              <p>"{quote.quote_text}"</p>
              <div className="quote-author">— {quote.quote_author}</div>
            </motion.div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default QuoteSection;